import { create } from 'zustand';

interface WorldCupTeamFlagState {
  flagImagesByTeamName: Record<string, string>;
  setTeamFlagImages: (items: Array<{ teamName: string; flagImage?: string | null }>) => void;
  getTeamFlagImage: (teamName?: string | null) => string | undefined;
}

function normalizeTeamName(value?: string | null) {
  return String(value ?? '')
    .trim()
    .toLowerCase();
}

export const useWorldCupTeamFlagStore = create<WorldCupTeamFlagState>((set, get) => ({
  flagImagesByTeamName: {},
  setTeamFlagImages: (items) => {
    set((state) => {
      const next = { ...state.flagImagesByTeamName };
      let didChange = false;

      items.forEach((item) => {
        const teamName = normalizeTeamName(item.teamName);
        const flagImage = item.flagImage?.trim();
        if (!teamName || !flagImage || next[teamName] === flagImage) return;

        next[teamName] = flagImage;
        didChange = true;
      });

      return didChange ? { flagImagesByTeamName: next } : state;
    });
  },
  getTeamFlagImage: (teamName) => {
    const normalizedTeamName = normalizeTeamName(teamName);
    if (!normalizedTeamName) return undefined;

    return get().flagImagesByTeamName[normalizedTeamName];
  },
}));

export function getWorldCupTeamFlagImage(teamName?: string | null) {
  return useWorldCupTeamFlagStore.getState().getTeamFlagImage(teamName);
}
